import React from 'react';
import { Grid, Button, Dropdown, Form } from 'semantic-ui-react';
import { Helmet } from 'react-helmet';

const statusOptions = [
  { key: 'active', text: 'Active', value: 1 },
  { key: 'inactive', text: 'Inactive', value: 0 }
];

const UpdateProductForm = ({
  loading,
  disabled,
  productCodesDD,
  onChangeOfProductId,
  productName,
  onChangeOfProductName,
  submitLoading,
  handleSubmit,
  manufacturersDD,
  onChangeOfManufacturerId,
  selectedManufacturer,
  isActive,
  onChangeOfStatus
}) => (
  <Grid centered style={{ marginTop: '0px', padding: '10vh' }}>
    <Helmet>
      <title>Update Products </title>
    </Helmet>
    <Grid.Row centered>
      <Grid.Column width={5}>
        <h2
          style={{
            fontWeight: 400,
            marginBottom: '1em',
            border: '1px solid #555',
            textAlign: 'center',
            color: '#555',
            padding: '0.5em'
          }}
        >
          Update Products
        </h2>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row loading={loading}>
      <Grid.Column width={8}>
        <Form>
          <Form.Field required>
            <label>Select Product</label>
            <Dropdown
              placeholder="Select Product"
              loading={loading}
              selection
              search
              options={productCodesDD}
              onChange={onChangeOfProductId}
            />
          </Form.Field>
          <Form.Field required>
            <label>Product Name</label>
            <input
              placeholder="Rajma Chawal"
              value={productName}
              onChange={onChangeOfProductName}
              disabled={disabled}
            />
          </Form.Field>
          <Form.Field required>
            <label>Select Manufacturer</label>
            <Dropdown
              placeholder="Select Manufacturer"
              loading={loading}
              selection
              search
              value={selectedManufacturer}
              options={manufacturersDD}
              onChange={onChangeOfManufacturerId}
              disabled={disabled}
            />
          </Form.Field>
          <Form.Field required>
            <label>Is Active</label>
            <Dropdown
              placeholder="Select Status"
              loading={loading}
              selection
              search
              value={isActive}
              options={statusOptions}
              onChange={onChangeOfStatus}
              disabled={disabled}
            />
          </Form.Field>

          <Button
            basic
            color="blue"
            style={{ float: 'right' }}
            disabled={submitLoading || disabled}
            loading={submitLoading}
            onClick={handleSubmit}
          >
            Update Product
          </Button>
        </Form>
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

export default UpdateProductForm;



// WEBPACK FOOTER //
// ./src/Modules/UpdateProducts/component.jsx